<br><br><br>
<div class="container-fluid">
    <div class="row">
        <div class="col-md-1 col-sm-12" [ngClass]="gfg == true ? 'mostrar' : 'ocultar'" style="padding: 0.25rem; text-align: center; background-color: #ECECEC;">
            <button type="button" class="btn btn-sm" (click)="cambio()">
                <i class="fa-solid fa-bars fa-2x"></i>
            </button>
            <br>
            <hr>
            <ul class="lista-menu">
                <li data-toggle="tooltip" data-placement="right" title="Inicio" (click)="seccion(1)" [ngClass]="pantalla == 1 ? 'activa':''"><i class="fa fa-house-user fa-2xl" aria-hidden="true"></i></li>
                <li (click)="abrirModal()" data-toggle="tooltip" data-placement="right" title="Cambiar periodo o sede"><i class="fas fa-exchange-alt fa-2xl" aria-hidden="true"></i></li>
                <li data-toggle="tooltip" data-placement="right" title="Matricula" (click)="seccion(3)" [ngClass]="pantalla == 3 ? 'activa':''"><i class="fa fa-file-pen fa-2xl" aria-hidden="true"></i> </li>
                <li data-toggle="tooltip" data-placement="right" title="Periodo Actual" (click)="seccion(4)" [ngClass]="pantalla == 4 ? 'activa':''"><i class="fa fa-calendar-days fa-2xl" aria-hidden="true"></i> </li>
                <li data-toggle="tooltip" data-placement="right" title="Plan de Estudios" (click)="seccion(5)" [ngClass]="pantalla == 5 ? 'activa':''"><i class="fa fa-book-open fa-2xl" aria-hidden="true"></i></li>
                <li data-toggle="tooltip" data-placement="right" title="Record Histórico" (click)="seccion(6)" [ngClass]="pantalla == 6 ? 'activa':''"><i class="fa fa-folder-closed fa-2xl" aria-hidden="true"></i></li>
                <li data-toggle="tooltip" data-placement="right" title="Trámites Estudiantiles" (click)="seccion(7)" [ngClass]="pantalla == 7 ? 'activa':''"><i class="fa fa-file-contract fa-2xl" aria-hidden="true"></i></li>
                <li data-toggle="tooltip" data-placement="right" title="Servicios Estudiantiles" (click)="seccion(8)" [ngClass]="pantalla == 8 ? 'activa':''"><i class="fa fa-user-pen fa-2xl" aria-hidden="true"></i></li>
                <li data-toggle="tooltip" data-placement="right" title="Cuentas Pendientes" (click)="seccion(9)" [ngClass]="pantalla == 9 ? 'activa':''"><i class="fa fa-wallet fa-2xl" aria-hidden="true"></i></li>
                <li data-toggle="tooltip" data-placement="right" title="Oferta Académica" (click)="seccion(10)" [ngClass]="pantalla == 10 ? 'activa':''"><i class="fa fa-grip fa-2xl" aria-hidden="true"></i></li>
                <li data-toggle="tooltip" data-placement="right" title="Recursos" (click)="seccion(11)" [ngClass]="pantalla == 11 ? 'activa':''"><i class="fa fa-database fa-2xl" aria-hidden="true"></i></li>
                <li data-toggle="tooltip" data-placement="right" title="Calendario Institucional" (click)="seccion(12)" [ngClass]="pantalla == 12 ? 'activa':''"><i class="fa fa-calendar fa-2xl" aria-hidden="true"></i></li>
            </ul>
        </div>
        <div class="col-md-2 col-sm-12" [ngClass]="gfg == true ? 'ocultar' : 'mostrar'" style="background-color: #ECECEC;">
            <div class="row align-items-center">
                <div class="col-md-2 col-sm-6" (click)="cambio()" style="cursor: pointer;">
                    <i style="padding-left: 0.5rem" class="fa fa-bars fa-2x"></i>
                </div>
                <div class="col-md-10 col-sm-6 text-center"> 
                    <img src="/assets/images/avatarsys.png" style="max-width: 250px; width: 100%;" alt="avatar">
                </div>
            </div>
            
            <hr>

         <!--   <div class="row gx-1 align-items-center">
                <div class="col-md-4 text-center">
                    <img src="/assets/images/user.png" alt="user" style="max-width: 250px; width: 100%;" class="rounded-circle text-center border border-primary">
                </div>
                <div class="col-md-8 azul">
                    <h5>Bienvenido</h5>
                    <h5 style="color: black">{{datosPersonales.M12NOM}} {{datosPersonales.M12AP1}} {{datosPersonales.M12AP2}}</h5>
                    <h5><b>ID: </b> {{datosPersonales.M12CAR}}</h5>
                    <h5><b>Sede:</b> {{strSede}}</h5>
                    <h5 (click)="abrirPerfil()"><b style="text-decoration: underline; cursor: pointer;">Editar
                        detalles></b></h5>
                </div>
            </div>

            <hr> -->

            <div class="row">
                <div class="col-md-12">
                    <ul class="lista-menu" style="padding-left: 0.5rem">
                        <li (click)="seccion(1)" [ngClass]="pantalla == 1 ? 'activa':''">
                            <div class="row align-items-center">
                                <div class="col-md-2"><i class="fa fa-house-user fa-2x" aria-hidden="true"></i></div>
                                <div class="col-md-10"> Inicio</div>
                            </div>
                        </li>
                        <li (click)="abrirModal()">
                            <div class="row align-items-center">
                                <div class="col-md-2"><i class="fa fa-exchange-alt fa-2x" aria-hidden="true"></i></div>
                                <div class="col-md-10"> Cambiar periodo o sede</div>
                            </div>
                        </li>
                        <li (click)="seccion(3)" [ngClass]="pantalla == 3 ? 'activa':''">
                            <div class="row align-items-center">
                                <div class="col-md-2"><i class="fa fa-file-pen fa-2x" aria-hidden="true"></i></div>
                                <div class="col-md-10"> Matricula</div>
                            </div>
                        </li>
                        <li (click)="seccion(4)" [ngClass]="pantalla == 4 ? 'activa':''">
                            <div class="row align-items-center">
                                <div class="col-md-2"><i class="fa fa-calendar-days fa-2x" aria-hidden="true"></i></div>
                                <div class="col-md-10"> Periodo Actual</div>
                            </div>
                        <li (click)="seccion(5)" [ngClass]="pantalla == 5 ? 'activa':''">
                            <div class="row align-items-center">
                                <div class="col-md-2"><i class="fa fa-book-open fa-2x" aria-hidden="true"></i></div>
                                <div class="col-md-10"> Plan de Estudios</div>
                            </div>
                        </li>
                        <li (click)="seccion(6)" [ngClass]="pantalla == 6 ? 'activa':''">
                            <div class="row align-items-center">
                                <div class="col-md-2"><i class="fa fa-folder-closed fa-2x" aria-hidden="true"></i></div>
                                <div class="col-md-10"> Record Histórico</div>
                            </div>
                        </li>
                        <li (click)="seccion(7)" [ngClass]="pantalla == 7 ? 'activa':''">
                            <div class="row align-items-center">
                                <div class="col-md-2"><i class="fa fa-file-contract fa-2x" aria-hidden="true"></i></div>
                                <div class="col-md-10"> Trámites Estudiantiles</div>
                            </div>    
                        </li>
                        <li (click)="seccion(8)" [ngClass]="pantalla == 8 ? 'activa':''">
                            <div class="row align-items-center">
                                <div class="col-md-2"><i class="fa fa-user-pen fa-2x" aria-hidden="true"></i></div>
                                <div class="col-md-10"> Servicios Estudiantiles</div>
                            </div>    
                        </li>
                        <li (click)="seccion(9)" [ngClass]="pantalla == 9 ? 'activa':''">
                            <div class="row align-items-center">
                                <div class="col-md-2"><i class="fa fa-wallet fa-2x" aria-hidden="true"></i></div>
                                <div class="col-md-10"> Cuentas Pendientes</div>
                            </div>    
                        </li>
                        <li (click)="seccion(10)" [ngClass]="pantalla == 10 ? 'activa':''">
                            <div class="row align-items-center">
                                <div class="col-md-2"><i class="fa fa-grip fa-2x" aria-hidden="true"></i></div>
                                <div class="col-md-10"> Oferta Académica</div>
                            </div>    
                        </li>
                        <li (click)="seccion(11)" [ngClass]="pantalla == 11 ? 'activa':''">
                            <div class="row align-items-center">
                                <div class="col-md-2"><i class="fa fa-database fa-2x" aria-hidden="true"></i></div>
                                <div class="col-md-10"> Recursos</div>
                            </div>    
                        </li>
                        <li (click)="seccion(12)" [ngClass]="pantalla == 12 ? 'activa':''">
                            <div class="row align-items-center">
                                <div class="col-md-2"><i class="fa fa-calendar fa-2x" aria-hidden="true"></i></div>
                                <div class="col-md-10"> Calendario Institucional</div>
                            </div>    
                        </li>
                    </ul>
                </div>
            </div>  
        </div>
        <div class="col-sm-12" id="contenedor-estudiante" [ngClass]="gfg == true ? 'col-md-11' : 'col-md-10'" style="background-color: #f7f8fa; padding: 0.25rem">
            <ng-container [ngSwitch]="pantalla">
                <div class="container-fluid" *ngSwitchCase="1">
                    <div class="row mb-2">
                        <div class="col-md-12">
                            <div class="row align-items-center">
                                <div class="col-md-1 text-center">
                                    <i class="fa-solid fa-comments fa-2xl"></i>
                                </div>
                                <div class="col-md-11">
                                    <h5>{{cintillo}}</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-12">
                            <!-- mospina 10-10-16 EPT-2380 Cambio general identidad AVATAR -->
                            <div class="rounded" style="background-color: var(--app-claro, #53aaed); padding: 0.5em 0;">
                                <div class="row align-items-center" style="color: white; text-align: center;">
                                    <div class="col-md-2"><i class="fa fa-home-user fa-2x"></i></div>
                                    <div class="col-md-8">
                                        <h4 class="mb-0" style="color: white">INICIO</h4>
                                    </div>
                                </div>
                            </div>
                            <div style="background-color: black; padding: 0.5em 0; color: white;">
                                <div class="row align-items-center">
                                    <div class="col-md-2 offset-md-8 offset-sm-0 col-sm-12" style="text-align: right">
                                        <h5 class="mb-0" style="color: white; padding-right: 1em;">
                                            <i class="fa-regular fa-calendar"></i> &nbsp; {{ahora | date: 'yyyy/MM/dd' }}
                                        </h5>
                                    </div>
                                    <div class="col-md-2 col-sm-12" style="text-align: right">
                                        <h5 class="mb-0" style="color: white; padding-right: 1em;">
                                            <i class="fa-regular fa-clock"></i>&nbsp; {{ahora | date: 'hh:mm:ss a' }}
                                        </h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row gx-1 align-items-center">
                        <div class="col-md-4 text-center">
                            <img src="/assets/images/user.png" alt="user" style="max-width: 250px; width: 100%;" class="rounded-circle text-center border border-primary">
                        </div>
                        <div class="col-md-8 azul">
                            <h5>Bienvenido</h5>
                            <h5 style="color: black">{{datosPersonales.M12NOM}} {{datosPersonales.M12AP1}} {{datosPersonales.M12AP2}}</h5>
                            <h5><b>ID: </b> {{datosPersonales.M12CAR}}</h5>
                            <h5><b>Sede:</b> {{strSede}}</h5>
                            <h5 (click)="abrirPerfil()"><b style="text-decoration: underline; cursor: pointer;">Editar
                                detalles></b></h5>
                        </div>
                    </div>
        
                </div>
                <app-matricula *ngSwitchCase="3" (cerrarBarra)="cerrarBarra($event)" [sedes]="sedes" [sedeSeleccionada]="sedeSeleccionada" [ahora]="ahora" [cintillo]="cintillo"
                [datosPersonales]="datosPersonales"></app-matricula>
                <app-cuentas-pendientes *ngSwitchCase="9"></app-cuentas-pendientes>
                <app-periodo-actual *ngSwitchCase="4" [sedes]="sedes" [sedeSeleccionada]="sedeSeleccionada" 
                [periodos]="periodos" [periodoSeleccionado]="periodoSeleccionado" [carreras]="carreras" [M04IUP]="M04IUP" [ahora]="ahora" [cintillo]="cintillo"></app-periodo-actual>
                <app-plan-estudios *ngSwitchCase="5" [ahora]="ahora" [cintillo]="cintillo"></app-plan-estudios>
                <app-record-historico *ngSwitchCase="6" [ahora]="ahora" [cintillo]="cintillo"></app-record-historico>
                <app-tramites-estudiantiles *ngSwitchCase="7" [ahora]="ahora" [cintillo]="cintillo"></app-tramites-estudiantiles>
                <app-servicios-estudiantiles *ngSwitchCase="8" [ahora]="ahora" [cintillo]="cintillo"></app-servicios-estudiantiles>
                <app-oferta-academica *ngSwitchCase="10" [ahora]="ahora" [cintillo]="cintillo"></app-oferta-academica>
                <app-recursos *ngSwitchCase="11" [ahora]="ahora" [cintillo]="cintillo"></app-recursos>
                <app-calendario-institucional *ngSwitchCase="12" [ahora]="ahora" [cintillo]="cintillo"></app-calendario-institucional>
            </ng-container>          
        </div>
    </div>